import { CenteredPage } from '../components/Shell';
import { LocaleSwitcher } from '../components/LocaleSwitcher';
import { useT } from '../hooks';
import { useServices } from '../services';

/** Signed in, but without outlet_staff / dealer_staff: point to the Admin_Portal. */
export function NotOperatorPage() {
  const t = useT();
  const { config, session } = useServices();
  return (
    <CenteredPage logo>
      <div className="card__toolbar">
        <LocaleSwitcher />
      </div>
      <h1>{t('operator.notOperator.title')}</h1>
      <p>{t('operator.notOperator.body')}</p>
      <p>
        <a className="button button--primary button--block" href={config.adminUrl}>
          {t('operator.notOperator.openAdmin')}
        </a>
      </p>
      <button type="button" className="button button--block" onClick={() => void session.signOut()}>
        {t('operator.header.signOut')}
      </button>
    </CenteredPage>
  );
}
